import * as ACTION from './suppliers.actionTypes';

export const saveSuppliers = (suppliers) => async (dispatch) => {
    dispatch({
        type: ACTION.SUPPLIERS_BUY_DEALER,
        result: suppliers,
    })
};